module.exports = __webpack_public_path__ + "static/media/control tower.7e7e5e69.svg";